import Indicador from "..";
import IBFEditFields from "./components/IBFEditFields";
import { IBFParamFields } from "./components/IBFParamFields";
import ibfReport from "./reports";
import ibfReportSummary from "./reports/summary";

export default class IBF extends Indicador {
    static get fullName() {
        return "Infestação de Broca Final";
    }

    static get abbrev() {
        return "IBF";
    }

    static get legacyApontamentoMap() {
        return {
            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            seletorImplementoDF: "implemento",
            frente: "frente",

            coletas: {
                type: Array,
                newField: "coletas",
                children: {
                    entrenos: "entrenos",
                    brocados: "brocados",
                    observacao: "observacao",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",
            totalcanas: "totalCanas",
            totalentrenos: "totalEntrenos",
            totalbrocados: "totalBrocados",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            metaIBFManual: "manual.meta",

            metaIBFMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <IBFParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <IBFEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return ibfReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ibfReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        // console.log("apontamento.coletas", apontamento.coletas)
        if (!apontamento.coletas
            || !params
            || apontamento.coletas.length === 0
            || (apontamento.coletas.filter(c => c.entrenos).length === 0)
        ) {
            return 0;
        }

        const total = apontamento.coletas.length;
        apontamento.totalEntrenos = 0;
        apontamento.totalBrocados = 0;

        for (const coleta of apontamento.coletas) {
            let base = 0
            let meio = 0
            let ponta = 0

            if (coleta.base) {
                base = f(coleta.base)
            }
            if (coleta.meio) {
                meio = f(coleta.meio)
            }
            if (coleta.ponta) {
                ponta = f(coleta.ponta)
            }

            coleta.brocados = base + meio + ponta

            if (coleta.entrenos) {
                // coleta.entrenos = f(coleta.entrenos).toFixed(0)
                // apontamento.totalEntrenos += coleta.entrenos
                apontamento.totalEntrenos += f(coleta.entrenos)
            }

            if (coleta.brocados) {
                // coleta.brocados = f(coleta.brocados).toFixed(0)
                // apontamento.totalBrocados += coleta.brocados
                apontamento.totalBrocados += f(coleta.brocados)
            }
        }

        apontamento.totalCanas = f(total).toFixed(0);
        apontamento.totalEntrenos = f(apontamento.totalEntrenos).toFixed(2);
        apontamento.totalBrocados = f(apontamento.totalBrocados).toFixed(2);

        return ((100 * f(apontamento.totalBrocados)) / f(apontamento.totalEntrenos)).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatusInverte(conformidade, meta, 117.05, 100, 83.61);
    }
    // static getTableRelApontamentos(paramsCliente, IndicadorClass) {
    //     return [
    //         { title: "Data", width: 50, getValue: (a) => a.dataRef.split("-").reverse().join('/') },
    //         { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
    //         { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 25 },
    //         { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
    //         { title: "Talhão", field: "talhao.nome" },
    //         { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
    //         { title: "Implemento", field: "implemento.numeroFrotaImplemento", width: 'auto' },
    //         { title: "Frente", field: "frente", width: 'auto' },

    //         { title: "Canas", field: "totalCanas", width: 'auto' },
    //         { title: "Brocados", field: "totalBrocados", width: 'auto' },
    //         { title: "Entrenós", field: "totalEntrenos", width: 'auto' },

    //         {
    //             title: "% Infestação", field: "conformidade", width: 'auto', getColor: a => {
    //                 return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
    //             }
    //         },

    //     ]
    // }

    static getResultStr(apontamento) {
        return "Canas: " + apontamento.totalCanas +
            ", Brocados: " + apontamento.totalBrocados +
            " e Entrenós: " + apontamento.totalEntrenos
    }
}
